<!-- views/Login.vue -->
<template>
  <div class="login-container">
    <vxe-card  title="用户登录">
      <vxe-form 
        ref="formRef" 
        :data="formData" 
        :rules="rules" 
        @submit="handleLogin"
        title-width="80px"
        class="login-form"
      >
        <vxe-form-item field="username" title="用户名" >
          <vxe-input v-model="formData.username" placeholder="请输入用户名"></vxe-input>
        </vxe-form-item>
        
        <vxe-form-item field="password" title="密码" >
          <vxe-password-input v-model="formData.password" type="password" placeholder="请输入密码"></vxe-password-input>
        </vxe-form-item>
        
        <vxe-form-item align="center" :span="24">
          <vxe-button type="submit" status="primary" content="登录"></vxe-button>
        </vxe-form-item>
      </vxe-form>
    </vxe-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useTabsStore } from '@/pinia/index'
import request from '@/request/request'
import { VxeUI } from 'vxe-pc-ui'
import CryptoJS from 'crypto-js';
const router = useRouter()
const route = useRoute()
const userStore = useTabsStore()

const formRef = ref(null)
const formData = reactive({
  username: '',
  password: ''
})

const rules = {
  username: [
    { required: true, message: '请输入用户名' }
  ],
  password: [
    { required: true, message: '请输入密码' }
  ]
}
// 前端
async function sha256(text) {
  return CryptoJS.SHA256(text).toString(CryptoJS.enc.Hex);
}
const handleLogin = async () => {
  const errMap = await formRef.value.validate()
  if (errMap) return

  // 模拟登录请求
  try {
    // 这里替换为真实的 API 调用
    const res = await request.post('/Login/Login', {
      user_name: formData.username,
      user_password: await sha256(formData.password)
    })
    
    if (res.success) {
      // 模拟成功
      const mockToken = 'mock-token-' + Date.now()
      // userStore.setToken(mockToken)

      // 跳转回原本想去的页面，或者首页
      const redirect = '/MainLayout'
      router.push(redirect)
    }
    else
    {
      // 模拟失败
      VxeUI.modal.message({
    id: 'myUniqueMsg',
    content: '登录失败:'+res.message,
    status: 'error'
  })
    }
  } catch (error) {
    VxeUI.modal.message({
    id: 'myUniqueMsg',
    content: '登录失败:'+error,
    status: 'error'
  })
    // 显示错误提示
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f0f2f5;
}

.login-form {
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>